// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__V1miF","indicatorHolder":"styles_indicatorHolder__1cP5b"};